<template>
    <v-card min-height="555" v-if="rede_data">
        <v-stepper v-model="step" style="box-shadow: none;">
            <v-stepper-items>
                <v-stepper-content class="pa-0" step="1">
                  <v-layout column class="pa-4">
                    <h2 style="width: 100%; text-align: center;" class="mb-2">Edite sua Rede</h2>
                    <v-flex align-self-center>
                        <img v-if="(imagem ||rede_data.url_logo) && mostrar" :src="!imagem ? rede_data.url_logo : imagem" alt="Logo da rede" width="250">
                        <v-card color="grey" height="250" width="250" v-if="!imagem && !croppingLogo && !rede_data.url_logo">
                            <v-layout justify-center align-center fill-height>
                                <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                            </v-layout>
                        </v-card>
                        <v-layout justify-center align-center fill-height v-if="!imagem">
                                <v-flex xs12 v-show="croppingLogo">
                                    <vue-croppie
                                    ref="croppieRef"
                                    :enableExif="true"
                                    :enforceBoundary="true"
                                    :enableResize="false"
                                    :enableOrientation="false"
                                    :mouseWheelZoom="true"
                                    :showZoomer="false"
                                    :boundary="{ width: 250, height: 250 }"
                                    :viewport="{ width: 200, height: 200, type : 'circle' }"
                                    ></vue-croppie>
                                    <v-btn
                                    flat
                                    @click="recortarLogo"
                                    color="grey darken-2"
                                    block
                                    class="mt-3"
                                    >Recortar imagem</v-btn>
                                </v-flex>
                        </v-layout>
                        <v-btn class="mt-3" block color="primary" @click="$refs.logoInput.click()" v-if="mostrar">
                            Inserir imagem
                            <input
                                type="file"
                                style="display:none"
                                accept="image/*"
                                ref="logoInput"
                                @input="carregarLogo"
                            />
                        </v-btn>
                    </v-flex>
                    <v-text-field class="mt-3" outline label="Nome da rede" v-model="rede_data.nome"/>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="2">
                  <v-layout column class="pa-4">
                    <h2 style="width: 100%; text-align: center;" class="mb-2">Insira a capa da rede</h2>
                    <v-flex align-self-center>
                      <img v-if="(capa ||rede_data.capa) && mostrar2" :src="!capa ? rede_data.capa : capa" alt="Capa da rede" width="500">
                      <v-card color="grey" height="250" width="500" v-if="!capa && !croppingCapa && !rede_data.capa">
                          <v-layout justify-center align-center fill-height>
                              <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                          </v-layout>
                      </v-card>
                      <v-layout justify-center align-center fill-height v-if="!capa">
                        <v-flex xs12 v-show="croppingCapa">
                            <vue-croppie
                            ref="croppieCapaRef"
                            :enableExif="true"
                            :enforceBoundary="true"
                            :enableResize="false"
                            :enableOrientation="false"
                            :mouseWheelZoom="true"
                            :showZoomer="false"
                            :boundary="{ width: 500, height: 250 }"
                            :viewport="{ width: 350, height: 200}"
                            ></vue-croppie>
                            <v-btn
                            flat
                            @click="recortarCapa"
                            color="grey darken-2"
                            block
                            class="mt-3"
                            >Recortar imagem</v-btn>
                        </v-flex>
                      </v-layout>
                      <v-btn class="mt-3" block color="primary" @click="$refs.capaInput.click()" v-if="mostrar2">
                          Inserir imagem
                          <input
                              type="file"
                              style="display:none"
                              accept="image/*"
                              ref="capaInput"
                              @input="carregarImagem"
                          />
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="3">
                  <v-layout row wrap justify-center class="pa-2">
                    <v-flex xs12>
                      <h2 class="text-xs-center">Alterar o principal posto da rede</h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                          <v-list-tile
                            v-for="(posto, index) in postosDaRede"
                            :key="index"
                            ripple
                            @click="inserirPostoMatriz(posto)"
                            :style="{'border': posto.cnpj == rede.matriz.cnpj ? '1px solid #003366' : 'none', 'border-radius': posto.cnpj == rede.matriz.cnpj ? '15px' : '0px'}"
                          >
                              <v-list-tile-avatar>
                                  <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="postosDaRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="4">
                  <v-layout row wrap justify-space-between class="pa-2">
                        <v-flex xs12>
                            <h2 class="text-xs-center">Alterar postos da rede</h2>
                        </v-flex>
                        <v-flex xs6>
                            <h4 class="text-xs-center">Postos sem rede</h4>
                            <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                                <v-list-tile
                                  v-for="(posto, index) in postosSemRede"
                                  :key="index"
                                  ripple
                                  @click="inserirEmRede(posto, index)"
                                >
                                    <v-list-tile-avatar>
                                        <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                        <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                        <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="postosSemRede.length === 0">
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-flex xs6>
                            <h4 class="text-xs-center">Postos da rede</h4>
                            <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                                <v-list-tile
                                  v-for="(posto, index) in postosDaRede"
                                  :key="index"
                                  ripple
                                  @click="removerDaRede(posto, index)"
                                  :style="{'border': posto.cnpj == matriz.cnpj ? '1px solid #003366' : 'none', 'border-radius': posto.cnpj == matriz.cnpj ? '15px' : '0px'}"
                                >
                                    <v-list-tile-avatar>
                                        <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                        <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                        <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="postosDaRede.length === 0">
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-footer
            class="pa-2"
            padless
            color="white"
            v-bind="{'absolute' : true}"
        >
            <v-btn class="mb-4" @click="$emit('fechar')">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mb-4" :disabled="!mostrar || !mostrar2" @click="btnEditar">Salvar</v-btn>
        </v-footer>
    </v-card>
</template>
<script>
export default {
  props: ['rede'],
  data () {
    return {
      step: 1,
      rede_data: {},
      postosSemRede: [],
      postosDaRede: [],
      croppingLogo: false,
      croppingCapa: false,
      mostrar: true,
      mostrar2: true,
      imagem: null,
      matriz: null,
      capa: null
    }
  },
  beforeMount () {
    if (this.rede) {
      this.rede_data = this.rede
      this.matriz = this.rede.matriz
    }
  },
  mounted () {
    this.pegarPostoSemRede()
    if (this.rede) {
      this.pegarPostoDaRede(this.rede.id_rede)
    }
  },
  methods: {
    btnEditar () {
      switch (this.step) {
        case 1:
          if (this.imagem) {
            this.$store.dispatch('inserirArquivoFirebase', {
              arquivo: this.imagem,
              prefixo: 'redes/logo/',
              id: this.rede_data.id_rede,
              local: 'redes',
              tipo: 'png'
            }).then(downloadUrl => {
              this.rede_data.url_logo = downloadUrl
              this.$store.dispatch('atualizarRede', {
                id_rede: this.rede_data.id_rede,
                nome: this.rede_data.nome,
                url_logo: this.rede_data.url_logo
              })
            }).then(() => {
              this.step++
            })
          } else {
            this.$store.dispatch('atualizarRede', {
              id_rede: this.rede_data.id_rede,
              nome: this.rede_data.nome
            }).then(result => {
              this.step++
            })
          }
          break
        case 2:
          if (this.capa) {
            this.$store.dispatch('inserirArquivoFirebase', {
              arquivo: this.capa,
              prefixo: 'redes/capa/',
              id: this.rede_data.id_rede,
              local: 'redes/',
              tipo: 'png'
            }).then(downloadUrl => {
              this.rede_data.capa = downloadUrl
              this.$store.dispatch('atualizarRede', {
                id_rede: this.rede_data.id_rede,
                capa: this.rede_data.capa
              })
            }).then(() => {
              if (this.rede_data.tipo_rede === 1) {
                this.$emit('success', 'Editado com sucesso.')
                this.$emit('fechar')
              } else {
                this.step++
              }
            })
          } else {
            if (this.rede_data.tipo_rede === 1) {
              this.$emit('success', 'Editado com sucesso.')
              this.$emit('fechar')
            } else {
              this.step++
            }
          }
          break
        case 3:
          this.step++
          break
        case 4:
          this.$emit('success', 'Editado com sucesso.')
          this.$emit('fechar')
      }
    },
    carregarImagem (event) {
      this.capa = null
      this.mostrar2 = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingCapa = true
          this.$refs.croppieCapaRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieCapaRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    recortarCapa () {
      this.mostrar2 = true
      let options = {
        type: 'base64',
        format: 'png'
      }
      this.$refs.croppieCapaRef.result(options, output => {
        this.capa = output
        this.croppingCapa = false
      })
    },
    atualizarRede () {
      this.$store.dispatch('atualizarRede', {
        id_rede: this.rede_data.id_rede,
        nome: this.rede_data.nome,
        capa: this.rede_data.capa,
        url_logo: this.rede_data.url_logo
      }).then(() => {
        this.$emit('success', 'Editado com sucesso.')
        this.step++
      })
    },
    carregarLogo (event) {
      this.imagem = null
      this.mostrar = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingLogo = true
          this.$refs.croppieRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    recortarLogo () {
      this.mostrar = true
      let options = {
        type: 'base64',
        format: 'png',
        circle: true
      }
      this.$refs.croppieRef.result(options, output => {
        this.imagem = output
        this.croppingLogo = false
      })
    },
    pegarPostoSemRede () {
      this.$store.dispatch('postosSemRede').then(value => {
        this.postosSemRede = value.slice()
      })
    },
    pegarPostoDaRede (id) {
      this.$store.dispatch('postosDaRede', id).then(value => {
        this.postosDaRede = value.slice()
      })
    },
    inserirEmRede (posto, index) {
      const naoExiste = !this.postosDaRede.find((p) => p.cnpj === posto.cnpj)
      if (naoExiste) {
        this.postosDaRede.push(posto)
        this.$store.dispatch('inserirEmRede', {
          lista: this.postosDaRede.map(p => p.cnpj),
          id_rede: this.rede.id_rede
        }).then(() => {
          this.postosSemRede.splice(index, 1)
        })
      } else {
        this.$emit('error', 'O posto já pertence a rede.')
      }
    },
    removerDaRede (posto, index) {
      this.$store.dispatch('removerDaRede', {
        id: this.rede.id_rede,
        cnpj: posto.cnpj
      }).then(() => {
        this.postosSemRede.push(posto)
        this.postosDaRede.splice(index, 1)
      }).catch(error => {
        this.$emit('error', error)
      })
    },
    inserirPostoMatriz (posto) {
      this.matriz = posto
      this.$store.dispatch('inserirPostoMatriz', {
        id: this.rede.id_rede,
        cnpj: posto.cnpj
      }).then(() => {
        this.pegarPostoSemRede()
        this.$emit('success', 'Posto principal selecionado com sucesso.')
        this.step++
      })
    }
  }
}
</script>
